/**
 * GET /api/auth/pats — list of the current user's Personal Access Tokens.
 * POST /api/auth/pats — create a new PAT (returns rawToken ONE TIME only).
 * DELETE /api/auth/pats/:patId — revoke a PAT.
 *
 * rawToken is returned only on creation and MUST NOT be persisted beyond the
 * one-time reveal modal lifecycle.
 */
import { z } from 'zod';

export const PatSchema = z.looseObject({
  patId: z.string().min(1),
  label: z.string().min(1),
  createdAt: z.string(),
  lastUsedAt: z.string().nullable().optional(),
  scopes: z.array(z.string()).optional(),
  tokenType: z.string().optional(),
});

export type Pat = z.infer<typeof PatSchema>;

export const PatsListResponseSchema = z.union([
  z.looseObject({ pats: z.array(PatSchema) }),
  z.array(PatSchema),
]);

export type PatsListResponse = z.infer<typeof PatsListResponseSchema>;

export const PatCreateResponseSchema = z.looseObject({
  patId: z.string().min(1),
  label: z.string().min(1),
  rawToken: z.string().min(47).max(128),
  createdAt: z.string(),
  scopes: z.array(z.string()).optional(),
  tokenType: z.string().optional(),
});

export type PatCreateResponse = z.infer<typeof PatCreateResponseSchema>;
